/* eslint-disable max-len */
import { Flex, Text, Radio, Pane, Toast } from '@leverege/ui-elements';
// import I18N from '@leverege/i18n'
import { GlobalState } from '@leverege/ui-redux';
import React, { useState, useEffect } from 'react';
import classes from './DataSharingViewClasses.css';

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
async function getIncomingTransfer({
  device,
  api
}) {
  const systemId = device.systemId;
  const orgId = device.data?.organization?.id;
  const companyId = device.data?.company?.id;
  const locationId = device.data?.location?.id;
  const incomingTransferId = device.data?.incomingTransfer?.id;
  let incomingTransfer;
  if (orgId) {
    incomingTransfer = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('transfers').obj(incomingTransferId).get();
  } else {
    incomingTransfer = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('transfers').obj(incomingTransferId).get();
  }
  return incomingTransfer;
}
export default function DataSharingEnabledEditorView(opts) {
  const {
    value: dataSharingEnabled,
    onChange: pOnChange,
    eventData
  } = opts;
  const [previousLocationName, setPreviousLocationName] = useState();
  const [buttonsEnabled, setButtonsEnabled] = useState(false);

  // const uiName = process.env.UI_NAME
  // const assetIndustryName = t( `assetIndustryName.${uiName}`, 'Asset' )

  const onChange = evt => {
    const updateData = {
      data: evt.data,
      value: evt.value
    };
    pOnChange(updateData);
  };
  const device = opts?.object?.data;
  const companyId = device.data?.company?.id;
  const locationId = device.data?.location?.id;
  const deviceBlueprintAlias = opts?.object?.type;
  const incomingTransferId = device.data?.incomingTransfer?.id;
  const deviceName = device.name;
  useEffect(() => {
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        if (!incomingTransferId) {
          return;
        }
        if (!companyId || !locationId) {
          // eslint-disable-next-line no-console
          console.log({
            msg: 'DataSharingEnabledEditorView - Device does not have Company and/or Location'
          });
          Toast.error(['Failed to Load Data Sharing Settings', `Please assign the ${deviceBlueprintAlias} to a Company and Location to load data sharing settings`]);
          setButtonsEnabled(false);
          return;
        }
        const state = getState();
        let incomingTransfer = state?.models?.lookup?.[incomingTransferId];
        if (!incomingTransfer) {
          // Doing it this roundabout way to make sure user has correct permissions, either at company or location level
          incomingTransfer = await getIncomingTransfer({
            device,
            api
          });
        }
        const prevLocationName = incomingTransfer?.data?.transferredFrom;
        setPreviousLocationName(prevLocationName);
        setButtonsEnabled(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({
          msg: 'DataSharingEnabledEditorView - Error getting data sharing info',
          err: error
        });
        Toast.error('Error in getting data sharing information');
        setButtonsEnabled(false);
      }
    });
  });

  // Asset was never transferred
  if (!incomingTransferId) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colS",
    children: [/*#__PURE__*/_jsxs(Text, {
      style: {
        paddingBottom: '16px'
      },
      children: ["Would you like to update your data sharing settings for ", /*#__PURE__*/_jsx("b", {
        children: deviceName
      }), ", allowing all users from its previous location to have view-only access to its details and location?"]
    }), /*#__PURE__*/_jsx(Pane, {
      style: {
        backgroundColor: 'white',
        borderRadius: '4px',
        border: '1px solid #ced6de',
        padding: '8px 16px 8px 16px'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "row",
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          children: " Previous Location "
        }), /*#__PURE__*/_jsxs(Text, {
          style: {
            fontWeight: 'bold'
          },
          children: [" ", previousLocationName ?? '', " "]
        })]
      })
    }), /*#__PURE__*/_jsx(Text, {
      style: {
        fontWeight: 'bold',
        paddingTop: '16px'
      },
      children: "Enable Data Sharing"
    }), /*#__PURE__*/_jsx("div", {
      style: {
        paddingTop: '16px'
      },
      children: /*#__PURE__*/_jsx(Radio, {
        className: classes.radioButton,
        label: "Yes, enable data sharing",
        labelVariant: "inputCaption",
        on: true,
        eventData: eventData,
        value: dataSharingEnabled,
        disabled: !buttonsEnabled,
        onChange: evt => {
          onChange({
            ...evt,
            value: true
          });
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        paddingTop: '16px'
      },
      children: /*#__PURE__*/_jsx(Radio, {
        className: classes.radioButton,
        label: "No, keep data sharing disabled",
        labelVariant: "inputCaption",
        on: false,
        eventData: eventData,
        value: dataSharingEnabled,
        disabled: !buttonsEnabled,
        onChange: evt => {
          onChange({
            ...evt,
            value: false
          });
        }
      })
    })]
  });
}